import styled from 'styled-components';
import { Colors, Row, Text, IcCopy } from 'basic-ui-lib';
import { IDevice } from 'modules/dashboard/interfaces/api';

interface DeviceInfoListProps {
  deviceInfo?: IDevice | null;
  screenId?: string;
  isCreateMode?: boolean;
}

const DeviceInfoList = ({ deviceInfo, screenId, isCreateMode }: DeviceInfoListProps) => {
  const handleCopy = (value: string) => {
    navigator.clipboard.writeText(value);
  };

  const ipAddress = deviceInfo?.ipAddress || '-';
  const hostname = deviceInfo?.hostName || '-';
  const displayScreenId = isCreateMode ? '-' : (screenId || '-');
  const operatingSystem = deviceInfo?.operatingSystem || '-';
  const timezone = deviceInfo?.timeZone || '-';
  const createdDate = isCreateMode ? '-' : (deviceInfo?.createdDate || '-');

  return (
    <Container>
      <InfoRow>
        <Text body_1 color="neutral.text.5">IP Address</Text>
        <Row gap={4} alignItems="center">
          <Text body_1 medium color="neutral.text.5">{ipAddress}</Text>
          {ipAddress !== '-' && (
            <CopyButton onClick={() => handleCopy(ipAddress)}>
              <IcCopy width={16} height={16} fill={Colors.neutral.text[4]} />
            </CopyButton>
          )}
        </Row>
      </InfoRow>

      <InfoRow>
        <Text body_1 color="neutral.text.5">Hostname</Text>
        <Row gap={4} alignItems="center">
          <Text body_1 medium color="neutral.text.5">{hostname}</Text>
          {hostname !== '-' && (
            <CopyButton onClick={() => handleCopy(hostname)}>
              <IcCopy width={16} height={16} fill={Colors.neutral.text[4]} />
            </CopyButton>
          )}
        </Row>
      </InfoRow>

      <InfoRow>
        <Text body_1 color="neutral.text.5">Screen ID</Text>
        <Row gap={4} alignItems="center">
          <Text body_1 medium color="neutral.text.5">{displayScreenId}</Text>
          {displayScreenId !== '-' && (
            <CopyButton onClick={() => handleCopy(displayScreenId)}>
              <IcCopy width={16} height={16} fill={Colors.neutral.text[4]} />
            </CopyButton>
          )}
        </Row>
      </InfoRow>

      <InfoRow>
        <Text body_1 color="neutral.text.5">Operating System</Text>
        <Text body_1 medium color="neutral.text.5">{operatingSystem}</Text>
      </InfoRow>

      <InfoRow>
        <Text body_1 color="neutral.text.5">OS Time zone</Text>
        <Text body_1 medium color="neutral.text.5">{timezone}</Text>
      </InfoRow>

      <InfoRow $noBorder>
        <Text body_1 color="neutral.text.5">Created Since</Text>
        <Text body_1 medium color="neutral.text.5" right>
          {createdDate}
        </Text>
      </InfoRow>
    </Container>
  );
};

export default DeviceInfoList;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: auto;
`;

const InfoRow = styled.div<{ $noBorder?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 12px 0;
  border-bottom: ${({ $noBorder }) => $noBorder ? 'none' : `1px solid ${Colors.neutral.border[1]}`};
`;

const CopyButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 2px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    opacity: 0.7;
  }
`;
